import CarouselPreferencesModalController from './modalCtrl/CarouselPreferencesModalController';
import IBCarouselController from './IBCarouselController';
import registerAsfCarouselDirective from './IBCarouselDirective';
import DeleteCarouselModalController from './modalCtrl/DeleteCarouselModalController';

export default function registerCarouselComponents(angular) {
    angular.module('assessmentFrontendDirectives')
        .controller('IBCarouselController', [
            '$scope', 'TaskDataService', '$signals', 'CMSSortableService', 
            '$uibModal', '$interval', '$timeout', '$config', 'TaskInfoService', 
            '$q', 'SheetLoadedService', IBCarouselController
        ]);

    registerAsfCarouselDirective(angular.module('assessmentFrontendDirectives'));

    angular.module('assessmentFrontendDirectives')
        .controller('CarouselPreferencesModalController', [
            '$scope', '$uibModalInstance', 'carousels', 'rows', 'contentObj',
            '$signals', 'TaskDataService', '$uibModal', 'DeleteObjectHelperService',
            'TaskInfoService', CarouselPreferencesModalController
        ]);
        
    angular.module('assessmentFrontendDirectives')
        .controller('DeleteCarouselModalController', [
            '$scope',
            '$uibModalInstance',
            DeleteCarouselModalController
        ]);
}